export const TID = {
    // Landing
    landing: {
        loginBtn: "landing-login-btn",
        registerBtn: "landing-register-btn",
        heroCta: "landing-hero-cta",
        featureCard: (i) => `landing-feature-${i}`,
    },
    // Auth
    auth: {
        emailInput: "auth-email-input",
        passwordInput: "auth-password-input",
        nameInput: "auth-name-input",
        roleSelect: "auth-role-select",
        submitBtn: "auth-submit-btn",
        error: "auth-error",
        switchToRegister: "auth-switch-to-register",
        switchToLogin: "auth-switch-to-login",
    },
    // Nav
    nav: {
        logoutBtn: "nav-logout-btn",
        userMenu: "nav-user-menu",
        brand: "nav-brand",
    },
    // Doctor dashboard
    doctor: {
        newPatientBtn: "doctor-new-patient-btn",
        newConsultationBtn: "doctor-new-consultation-btn",
        patientRow: (id) => `doctor-patient-row-${id}`,
        consultationRow: (id) => `doctor-consultation-row-${id}`,
    },
    // Patient form
    patient: {
        fullName: "patient-fullname-input",
        birthDate: "patient-birthdate-input",
        cpf: "patient-cpf-input",
        phone: "patient-phone-input",
        insurance: "patient-insurance-select",
        caregiverName: "patient-caregiver-name",
        caregiverPhone: "patient-caregiver-phone",
        submit: "patient-submit-btn",
    },
    // Consultation
    consultation: {
        typeSelect: "consultation-type-select",
        paymentModelSelect: "consultation-payment-model-select",
        patientSelect: "consultation-patient-select",
        postHosp: "consultation-post-hosp",
        scheduledAt: "consultation-scheduled-at",
        submit: "consultation-submit-btn",
        copyLinkBtn: "consultation-copy-link-btn",
        generatePlanBtn: "consultation-generate-plan-btn",
        savePlanBtn: "consultation-save-plan-btn",
        section: (id) => `consultation-section-${id}`,
        field: (key) => `consultation-field-${key}`,
    },
    // Intake public
    intake: {
        saveBtn: "intake-save-btn",
        submitBtn: "intake-submit-btn",
        sectionTab: (id) => `intake-tab-${id}`,
    },
};
